import React, {Component, Fragment} from "react";
import {Button, Card, CardBody} from "reactstrap";
import "../../views/Authenticated/Transactions/transaction.css";
import "flag-icon-css/css/flag-icon.css";
import "../../views/Authenticated/Beneficiaries/beneficiaries.css"

export default class BeneficiaryCard extends Component {

    render() {
        return <Fragment>
            {this.renderBeneficiaryCards(this.props.beneficiary)}
        </Fragment>
    }

    renderBeneficiaryCards(beneficiary) {
        return <Fragment>
            <Card style={{border: "none"}}>
                <CardBody className={"beneficiary_card"}>
                    <div className={"beneficiary_card_header"}>
                        {this.renderHeader(beneficiary)}
                    </div>
                    <div className={"beneficiary_card_body"}>
                        {this.renderBody(beneficiary)}
                    </div>
                </CardBody>
            </Card>
            <hr/>
        </Fragment>
    }

    renderModalBeneficiaryCard(beneficiary) {
        return <Fragment>
            {this.renderHeader(beneficiary)}
            <br/>
            {this.renderBody()}
        </Fragment>

    }

    renderHeader(beneficiary) {
        return <Fragment>
            <div style={{display: "flex", width: "100%"}}>
                <div className={"beneficiary_letter_div"}>
                    <div>
                        <div className={"beneficiary_letter_circle"}>
                            <span className={"beneficiary_letter"}>{beneficiary.beneficiaryLetter}</span>
                        </div>
                    </div>
                </div>
                <div className={"beneficiary_card_beneficiary_container"}>
                    <div className={"beneficiary_card_beneficiary_name"}>
                        {beneficiary.beneficiaryName}
                    </div>
                    <span className={"beneficiary_card_payout_partner"}>{this.props.beneficiary.payoutPartnerName}</span>
                </div>
                <div className={"beneficiary_card_icons"}>
                    <div onClick={() => this.props.onEditClick(this.props.beneficiary)}>
                        <span className={"fa fa-edit edit_icon"}/>
                    </div>
                    <div onClick={() => this.props.onDeleteClick(this.props.beneficiary)}>
                        <span className={"fa fa-trash trash_icon"}/>
                    </div>
                </div>
            </div>
        </Fragment>
    }

    renderBody() {
        return <Fragment>
            <div style={{textAlign: "center"}}>
                <Button className={"beneficiary_card_send_money_button"} onClick={() => this.props.onSendMoneyClick(this.props.beneficiary)}>Send Money Now</Button>
            </div>
        </Fragment>
    }
}
